import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '@/globals'

import { authGuard } from '../auth/authGuard'

// Layouts
import Layout1 from '@/layout/Layout1'
import LayoutBlank from '@/layout/LayoutBlank'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [{
    path: '/',
    component: LayoutBlank,
    children: [{
      beforeEnter: authGuard,
      path: '',
      component: () => import('@/components/Empty')
    }, {
      path: 'logout',
      component: () => import('@/components/Logout')
    }, {
      path: '404',
      component: () => import('@/components/404')
    }, {
      // beforeEnter: authGuard,
      path: 'authorization-failed',
      component: () => import('@/components/AuthorizationFailed')
    }]
  }, {
    path: '/',
    component: Layout1,
    children: [{
      beforeEnter: authGuard,
      path: ':customer/',
      component: () => import('@/components/InIpBlocked')
    }, {
      beforeEnter: authGuard,
      path: ':customer/inbound/ip-blocked',
      component: () => import('@/components/InIpBlocked')
    }, {
      beforeEnter: authGuard,
      path: ':customer/inbound/ip-archived',
      component: () => import('@/components/InIpArchived')
    }, {
      beforeEnter: authGuard,
      path: ':customer/inbound/ip-history/:ip',
      component: () => import('@/components/InIpHistory')
    }, {
      beforeEnter: authGuard,
      path: ':customer/inbound/ip-pro-blocked',
      component: () => import('@/components/InIpProBlocked')
    }, {
      beforeEnter: authGuard,
      path: ':customer/inbound/ip-pro-archived',
      component: () => import('@/components/InIpProArchived')
    }, {
      beforeEnter: authGuard,
      path: ':customer/inbound/ip-pro-history/:ip',
      component: () => import('@/components/InIpProHistory')
    }, {
      beforeEnter: authGuard,
      path: ':customer/inbound/ip-whitelisting',
      component: () => import('@/components/InIpWhitelisting')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/ip-blocked',
      component: () => import('@/components/OutIpBlocked')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/ip-archived',
      component: () => import('@/components/OutIpArchived')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/ip-history/:ip',
      component: () => import('@/components/OutIpHistory')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/ip-whitelisting',
      component: () => import('@/components/OutIpWhitelisting')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/url-blocked',
      component: () => import('@/components/OutUrlBlocked')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/url-archived',
      component: () => import('@/components/OutUrlArchived')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/url-history/:url*',
      component: () => import('@/components/OutUrlHistory')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/url-whitelisting',
      component: () => import('@/components/OutUrlWhitelisting')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/domain-blocked',
      component: () => import('@/components/OutDomainBlocked')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/domain-archived',
      component: () => import('@/components/OutDomainArchived')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/domain-history/:domain',
      component: () => import('@/components/OutDomainHistory')
    }, {
      beforeEnter: authGuard,
      path: ':customer/outbound/domain-whitelisting',
      component: () => import('@/components/OutDomainWhitelisting')
    }, {
      beforeEnter: authGuard,
      path: ':customer/field-registration/inbound-ip',
      component: () => import('@/components/InIpFieldRegistration')
    }, {
      beforeEnter: authGuard,
      path: ':customer/field-registration/outbound-ip',
      component: () => import('@/components/OutIpFieldRegistration')
    }, {
      beforeEnter: authGuard,
      path: ':customer/field-registration/outbound-url',
      component: () => import('@/components/OutUrlFieldRegistration')
    }, {
      beforeEnter: authGuard,
      path: ':customer/field-registration/outbound-domain',
      component: () => import('@/components/OutDomainFieldRegistration')
    }, {
      beforeEnter: authGuard,
      path: ':customer/retention-condition',
      component: () => import('@/components/RetentionCondition')
    }, {
      beforeEnter: authGuard,
      path: ':customer/blocklist-condition',
      component: () => import('@/components/BlocklistCondition')
    }, {
      beforeEnter: authGuard,
      path: ':customer/proactive-condition',
      component: () => import('@/components/ProactiveCondition')
    }, {
      beforeEnter: authGuard,
      path: ':customer/ti-lookup',
      component: () => import('@/components/TILookup')
    }, {
      beforeEnter: authGuard,
      path: ':customer/reporting',
      component: () => import('@/components/Reporting')
    }, {
      beforeEnter: authGuard,
      path: ':customer/report-scheduler',
      component: () => import('@/components/ReportSchedulerList')
    }, {
      beforeEnter: authGuard,
      path: ':customer/report-scheduler/create',
      component: () => import('@/components/ReportSchedulerCreate')
    }, {
      beforeEnter: authGuard,
      path: ':customer/report-scheduler/:reportId',
      component: () => import('@/components/ReportSchedulerEdit')
    }]
  }]
})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
